import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchCurrencies, fetchRmvMultiplier, fetchTranslations } from '../actions/wallet.action';

export const useAppSettings = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCurrencies());
    dispatch(fetchRmvMultiplier());
    dispatch(fetchTranslations());
  }, [dispatch]);
};
